"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var NotificationImportant_1 = __importDefault(require("@mui/icons-material/NotificationImportant"));
var DialogActionButton_1 = __importStar(require("../../dialog-action-button/DialogActionButton"));
/**
 * @component AlertModal
 * @example
 * return (
 *   <AlertModal
 *     isOpen={someBool}
 *     handleSaveCallback={someSaveFn}
 *     handleCloseCallback={someCloseFn}
 *     titleText="Alert"
 *     contentText="some Content Text"
 *   />
 * )
 * @param {boolean} isOpen whether the modal is open
 * @param {function} handleCloseCallback a fn to close the modal
 * @param {function} handleSaveCallback a fn to save some data
 * @param {IconShape} icon pass a material icon here
 * @param {string} contentText modal content text
 * @param {string} subtitleText subtitle text
 * @param {string} titleText title text
 * @param {boolean} includeCancelButton whether the modal should have a cancel button or not
 */
var AlertModal = function (props) {
    var isOpen = props.isOpen, handleCloseCallback = props.handleCloseCallback, handleSaveCallback = props.handleSaveCallback, icon = props.icon, contentText = props.contentText, subtitleText = props.subtitleText, titleText = props.titleText, includeCancelButton = props.includeCancelButton;
    return (react_1.default.createElement(material_1.Dialog, { className: "modal notify-modal", scroll: "body", open: isOpen, fullWidth: true, maxWidth: "md", color: "error" },
        react_1.default.createElement(material_1.DialogTitle, null,
            react_1.default.createElement("span", { className: "title" }, titleText)),
        react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement(material_1.Grid, { container: true, direction: "column", alignItems: "center" },
                react_1.default.createElement(material_1.Grid, { xs: 12, item: true, className: "mb-4 mt-2" }, icon ? react_1.default.createElement(material_1.Icon, { component: icon }) : react_1.default.createElement(NotificationImportant_1.default, { color: "error" })),
                react_1.default.createElement(material_1.Grid, { xs: 12, item: true, className: "mb-2" },
                    react_1.default.createElement(material_1.Typography, { variant: "subtitle1" }, subtitleText)),
                react_1.default.createElement(material_1.Grid, { xs: 12, item: true },
                    react_1.default.createElement(material_1.Typography, { variant: "body1" }, contentText)))),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(DialogActionButton_1.default, { isEnabled: true, savebuttonText: "Ok", saveStatus: DialogActionButton_1.saveCallbackStatus.none, executeSave: handleSaveCallback ? handleSaveCallback : handleCloseCallback, showCancelButton: includeCancelButton, handleCallbackCancel: handleCloseCallback }))));
};
exports.default = AlertModal;
